import React from 'react';
import {
  List, Datagrid, TextField, EditButton, SimpleForm, DisabledInput, Edit, Create, TextInput, Responsive,
  SimpleList, EmailField, SelectInput
} from 'admin-on-rest';
import {USER_ROLES_SELECT_INPUT} from "../../util/util";

export const UsersList = (props) => (
  <List {...props}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => `${record.firstName}, ${record.lastName}`}
          secondaryText={record => record.email}
        />
      }
      medium={
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" sortable={false} />
          <EmailField source="email" sortable={false} />
          <TextField source="firstName" label="First Name" sortable={false} />
          <TextField source="lastName" label="Last Name" sortable={false} />
          <TextField source="role.title" label="User Role" sortable={false} />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);

const UserTitle = ({ record }) => {
  return <span>User {record ? `"${record.firstName}, ${record.lastName}"` : ''}</span>;
};

export const UserEdit = (props) => (
  <Edit title={<UserTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <TextInput source="email" />
      <TextInput source="firstName" label="First Name" />
      <TextInput source="lastName" label="Last Name" />
      <SelectInput source="role.id" label="Role" choices={USER_ROLES_SELECT_INPUT} />
    </SimpleForm>
  </Edit>
);

export const UserCreate = (props) => (
  <Create title="Create User" {...props}>
    <SimpleForm>
      <TextInput source="email" />
      <TextInput source="firstName" label="First Name" />
      <TextInput source="lastName" label="Last Name" />
      <TextInput source="password" />
      <SelectInput source="role.id" label="Role" choices={USER_ROLES_SELECT_INPUT} />
    </SimpleForm>
  </Create>
);


// WEBPACK FOOTER //
// ./src/pages/users/users.js